<template>
  <div class="animated fadeIn">
    <div class="page-header d-flex">
      <h4 class="page-title">
        <i class="fas fa-list-alt"></i>
        탐지 목록
      </h4>
      <ul class="breadcrumbs ml-auto">
        <li class="nav-home mr-1">
          <a href="#">
            <i class="fas fa-home text-muted"></i>
          </a>
        </li>
        <li class="nav-item">
          <a class="font_15" href="#">WMDS</a>
        </li>
        <li class="separator">
          <i class="flaticon-right-arrow"></i>
        </li>
        <li class="nav-item">
          <a class="font_15 font-weight-bold" href="#">탐지</a>
        </li>
      </ul>
    </div>
    <!--//-------------------------------------------------------------------------검색조건-->
    <!-- detail search start -->
    <b-card v-show="so.adv">
      <b-row>
        <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
          <label class="col-form-label" for="opt_date">탐지 날짜</label>
        </b-col>
        <b-col class="col-xl-4 col-md-12 d-flex align-self-center">
          <b-form-group>
            <b-button class="md-2 ml-1" size="sm" variant="outline-primary" @click="set_sd('', 'created_at')"><i class="fa fa-remove"></i></b-button>
            <b-button class="md-2" size="sm" variant="primary" @click="set_sd('-1d', 'created_at')">-1일</b-button>
            <b-button class="md-2" size="sm" variant="primary" @click="set_sd('-1w', 'created_at')">-1주</b-button>
            <b-button class="md-2" size="sm" variant="primary" @click="set_sd('-1m', 'created_at')">-1달</b-button>
            <b-button class="md-2" size="sm" variant="primary" @click="set_sd('w', 'created_at')">1주</b-button>
            <b-button class="md-2" size="sm" variant="primary" @click="set_sd('m', 'created_at')">1달</b-button>
            <b-form inline class="mt-2">
              <date-picker @change="refresh" v-model="so.opt.created_at_sd" style="width: 140px" :lang="custom.lang.ko" :confirm="false" :first-day-of-week="1"></date-picker>
              ~
              <date-picker @change="refresh" v-model="so.opt.created_at_ed" style="width: 140px" :lang="custom.lang.ko" :confirm="false" :first-day-of-week="1"></date-picker>
            </b-form>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="mt-3">
        <b-col class="col-xl-2 col-md-12 d-flex align-self-center mb-3">
          <label class="col-form-label" for="code_ext">위험 수준</label>
        </b-col>
        <b-col class="col-xl-4 col-md-12 d-flex align-self-center">
          <b-form-group>
            <b-form-checkbox-group v-model="so.opt['level']" @change="refresh">
              <b-form-checkbox value="H">위험</b-form-checkbox> 
              <b-form-checkbox value="W">경고</b-form-checkbox>
              <b-form-checkbox value="N">조심</b-form-checkbox>
              <b-form-checkbox value="S">의심</b-form-checkbox>
            </b-form-checkbox-group>
          </b-form-group>
        </b-col>
        <b-col class="col-xl-2 col-md-12 d-flex align-self-center mb-3">
          <label class="col-form-label" for="code_type">타입</label>
        </b-col>
        <b-col class="col-xl-4 col-md-12 d-flex align-self-center">
          <b-form-group>
            <b-form-checkbox-group v-model="so.opt['type']" @change="refresh">
              <b-form-checkbox value="U">URL</b-form-checkbox>
              <b-form-checkbox value="S">String</b-form-checkbox>
              <b-form-checkbox value="R">Regex</b-form-checkbox>
              <b-form-checkbox value="M">MD5</b-form-checkbox>
            </b-form-checkbox-group>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="mt-3">
        <b-col class="col-xl-2 col-md-12 d-flex align-self-center mb-3">
          <label class="col-form-label" for="ph_search_opt_type">일치 유형</label>
        </b-col>
        <b-col class="col-xl-4 col-md-12 d-flex aign-self-center mt-2">
          <b-form-group>
            <b-form-radio-group v-model="so.opt['match_type']" @change="($event) = so.opt = Object.assign({}, so.opt, { match_type : $event })" name="ph_search_opt_type">
              <b-form-radio value="and">모두 일치</b-form-radio>
              <b-form-radio value="or">최소 한개 이상 일치</b-form-radio>
            </b-form-radio-group>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="float-right mt-3">
        <b-form-group>
          <b-button size="sm" variant="add" @click="refresh"> 찾기 </b-button>
          <b-button size="sm" variant="warning" @click="reset"> 초기화 </b-button>
          <b-button size="sm" variant="secondary" @click="search_opt"> 닫기 </b-button>
        </b-form-group>
      </b-row>
    </b-card>
    <!-- detail search end -->
    <div class="d-flex flex-wrap align-items-center">
      <b-col v-if="view_detail !== false" sm="2">
        <b-input-group size="sm">
          <div class="mr-auto mb7"></div>
        </b-input-group>
        <br>
        <b-input-group size="sm">
          <div class="mr-auto mb7"></div>
        </b-input-group>
        <br>
        <b-input-group size="sm">
          <div class="mr-auto mb7 mt-5">
            <span class="badge badge-primary">String : {{model.S | number}}</span>
            <span class="badge badge-info">MD5 : {{model.M | number}}</span>
            <span class="badge badge-warning">URL : {{model.U | number}}</span>
            <span class="badge badge-success">Regex : {{model.R | number}}</span>
          </div>
        </b-input-group>
      </b-col>
      <b-col :sm="view_detail !== false ? 10 : 12" class="md-10 d-flex flex-wrap align-items-center">
        <b-input-group size="sm">
          <div class="mr-auto mb7">
          </div>
          <div class="mb7 mr-2">
            <div class="form-inline">
              <label class="col-form-label mr-2" for="sel3">찾는 범위</label>
              <div class="input-group">
                <date-picker @change="refresh" v-model="so.created_at_sd" style="width: 140px" :lang="custom.lang.ko" :confirm="false" :first-day-of-week="1"></date-picker>
              </div>
              <span class="mx-2">~</span>
              <div class="input-group">
                <date-picker @change="refresh" v-model="so.created_at_ed" style="width: 140px" :lang="custom.lang.ko" :confirm="false" :first-day-of-week="1"></date-picker>
              </div>
            </div>
          </div>
        </b-input-group>
        <br>
        <b-input-group size="sm">
          <div class="mr-auto mb7"></div>
          <div class="mr-2 mb7 mt-2">
            <button class="btn btn-icon mr-1" @click="refresh()">
              <i class="fas fa-sync-alt"></i>
            </button>
            <button class="btn btn-icon mr-1" @click="reset()">
              <i class="fas fa-times"></i>
            </button>
          </div>
          <div class="mr-2 mb7">
            <select class="form-control" name="sel1" id="sel1" :disabled="so.adv" :text="so.skt || '찾기'" v-model="so.sk" @change="sv_reset">
              <option disabled value="">검색</option>
              <option value="domain">도메인</option>
              <option value="code">탐지된 코드</option>
              <option value="type">타입</option>
            </select>
          </div>
          <div class="mr-2 mb7">
            <select class="form-control" :disabled="so.adv" v-if="so.sk == 'type'" @change="refresh" v-model="so.sv">
              <option v-for="(item, index) in codes.WMDS_TYPE" :key="index" :value="index">{{ item }}</option>
            </select>
            <input type="text" class="form-control col-xl-12" name="input" id="input" :disabled="so.adv" v-if="so.sk != 'permissions' && so.sk != 'is_alive' && so.sk != 'type'" v-model="so.sv" @keyup.enter="refresh()">
          </div>
          <div class="mb7">
            <button class="btn btn-icon1 mr-1" @click="refresh">
              <i class="fas fa-search"></i>
            </button>
            <!-- <button class="btn btn-icon2" @click="search_opt">
              <i class="fas fa-search-plus" :class="{'fa-search-plus': !so.adv, 'fa-search-minus': so.adv }"></i>
            </button> -->
          </div>
        </b-input-group>
        <br>
        <b-input-group size="sm">
          <div class="mr-auto mb7"></div>
          <!-- <div class="mt-2">
            <div class="custom-control custom-checkbox">
              <b-checkbox @change="refresh" class="ml-3 mt-1" v-model="hide_del">삭제된 항목 숨기기</b-checkbox>
            </div>
          </div> -->
          <div class="mb7 mr-2">
            <span v-if="sync.enable" class="float-right" style="margin-right:15px">
              <i :class="`fa fa-refresh ${sync.th && sync.stop ? 'fa-spin' : ''}`" style="margin-right:5px"></i>
              <b-btn @click="pause" size="sm" variant="warning">
                {{!sync.stop ? "Auto refresh"  : "Pause"}}
              </b-btn>
            </span>
          </div>
          <div class="mb7">
            <select class="form-control" name="sel2" id="sel2" v-model="so.perPage" @change="refresh">
              <option disabled value="15">표시되는 개수 : 기본 15개</option>
              <option value=10>10</option>
              <option value=50>50</option>
              <option value=100>100</option>
            </select>

            <select v-if="sync.enable" v-model="sync.interval" @change="refresh" style="margin-right:15px">
              <option disabled value="15">Please select interval : Default 15</option>
              <option value=10>10</option>
              <option value=30>30</option>
              <option value=60>60</option>
              <option value=300>300(5 min)</option>
            </select>
          </div>
        </b-input-group>
      </b-col>
    </div>
    <!-- <div class="d-flex flex-wrap align-items-center">
      <div class="mr-auto mb7">
        <div class="mr-auto mb7 mt-2">
          <span class="badge badge-primary">String : {{model.S | number}}</span>
          <span class="badge badge-info">MD5 : {{model.M | number}}</span>
          <span class="badge badge-warning">URL : {{model.U | number}}</span>
          <span class="badge badge-success">Regex : {{model.R | number}}</span>
        </div>
      </div>
    </div> -->
    <!--//-------------------------------------------------------------------------검색조건-->
    <!--//-------------------------------------------------------------------------리스트출력-->
    <div class="reg_card">
      <div class="reg_card_body">
        <div class="table-responsive">
          <b-table class="table table_add table-striped" hover striped responsive="sm" ref="_list" show-empty empty-text="관련된 정보가 없어요."
            :items="load" :fields="fields" :current-page="so.currentPage" :per-page="so.perPage" :sortBy="so.sk" @row-clicked="detail" style="cursor:pointer;">
            <!-- <template slot="id" slot-scope="row">{{startRow - row.index}}</template>
            <template slot="status" slot-scope="row">
              <template v-if="row.item.is_del">
                <i class="fa fa-close" title="deleted user"></i>
              </template>
              <i v-if="row.item.is_alive" class="fa fa-unlock-alt" title="active user"></i>
              <i v-else class="fa fa-lock" title="inactive user"></i>
              <i v-if="row.item.is_verified" class="fa fa-envelope-open-o" title="email verified"></i>
            </template>
            <template slot="username" slot-scope="row">
              <del v-if="row.item.is_del">{{row.item.username}}</del>
              <template v-else>{{row.item.username}}</template>
            </template>
            <template slot="level" slot-scope="row">{{row.item.level | level}}</template>
            <template slot="group.name" slot-scope="row">{{row.item.group && row.item.group.name}}</template>
            <template slot="last_visit" slot-scope="row">{{row.item.last_visit | sdate }}</template>
            <template slot="func" slot-scope="row">
              <b-btn @click="detail(row.item)" size="sm" variant="outline-primary">More</b-btn>
            </template> -->
            <template slot="id" slot-scope="row">{{startRow - row.index}}</template>
            <template slot="domain" slot-scope="row">{{row.item.domain}}</template>
            <template slot="level" slot-scope="row">
              <b-badge v-if="row.item.level == 'H'" variant= "danger">위험</b-badge>
              <b-badge v-else-if="row.item.level == 'W'" variant= "warning">경고</b-badge>
              <b-badge v-else-if="row.item.level == 'N'" variant= "info">조심</b-badge>
              <b-badge v-else variant= "secondary">의심</b-badge>
            </template>
            <template slot="type" slot-scope="row">{{codes.WMDS_TYPE[row.item.type]}}</template>
            <template slot="code" slot-scope="row">{{row.item.code | truncate(40)}}</template>
            <template slot="created_at" slot-scope="row">{{row.item.created_at | datetime }}</template>
          </b-table>
        </div>
      </div>
    </div>
    <!--//-------------------------------------------------------------------------리스트출력-->
    <!--//-------------------------------------------------------------------------Pagination-->
    <div class="mt30">
      <b-pagination class="pagination justify-content-center" size="sm" :total-rows="getRowCount()" :per-page="so.perPage" v-model="so.currentPage" :limit="10" prev-text="<" next-text=">"  />
    </div>

    <!-- 시작 및 마지막 날짜 유무 확인 모달-->
    <b-modal title="기간 설정" size="xs" v-model="date_modal" @ok="date_modal = false" ok-variant="outline-primary" ok-only ok-title="확인">
      시작 날짜 및 마지막 날짜를 지정해야 조회가 가능합니다.
    </b-modal>

     <!-- 기간 설정 범위제한 모달-->
     <b-modal title="기간 설정" size="xs" v-model="year_modal" @ok="year_modal = false" ok-variant="outline-primary" ok-only ok-title="확인">
      탐지 목록은 최대 1년단위로 조회가 가능합니다.
    </b-modal>
    <!--//-------------------------------------------------------------------------Pagination-->
  </div>
</template>

<script>
  import App from './app.js'; export default Object.assign({}, App);
</script>